import styled from '@emotion/styled'
import { PAGE_BREAKPOINTS } from 'parameters/index'

export const FaqSectionWrapper = styled.div``

export const FaqSectionTop = styled.div`
	display: flex;
	justify-content: space-between;
	padding-bottom: 32px;
	align-items: center;
`

export const ShowOnDesktop = styled.div`
	display: block;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		display: none;
	}
`

export const ShowOnMobile = styled.div`
	display: none;

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		display: flex;
		align-items: center;
		justify-content: center;
	}
`
